import { combineReducers } from '@reduxjs/toolkit'

import message from './message'
import channel from './channel'
export default combineReducers({ message, channel })
